import React, { useContext } from 'react'

export type NavigationContextType = {
  status: number,
  origin?: string,
  href?: string,
}

export const NavigationContext = React.createContext<NavigationContextType>({
  status: 200,
})

export const useNavigationContext = () => useContext(NavigationContext)
